import { apiV2Root } from '#store/apiV2Root.ts';

const TOURS_TAG = 'TOURS';
const url = '/tours';

export const problemSlice = apiV2Root.injectEndpoints({
    endpoints: build => ({
        resolveProblem: build.mutation<void, string>({
            query: tourId => ({
                url: `${url}/${tourId}/problems/resolve`,
                method: 'POST',
            }),
            invalidatesTags: [TOURS_TAG],
        }),
    }),
});

export const { useResolveProblemMutation } = problemSlice;
